<template>
    <div class="row no-gutters body">
        <div class="col-12">
            <!-- page structure -->
            <div class="row no-gutters header">
                <div class="col d-flex">
                <div class="col-lg-3 col-md-2 col-sm-1" 
                    v-if="(routeName === 'createprofile'|| routeName === 'editprofile' || routeName === 'close' || routeName === 'notifications') || (routeName === 'Premium') || (routeName === 'payment_methods') || (routeName === 'purchase_history') || (routeName === 'recordScreeningQuestions') || !isOnline"
                >
                    <!-- <sidemenu class="sidemenu d-block d-sm-block d-md-block d-lg-none"></sidemenu> -->
                    <toggle-sidemenu class="sidemenu d-block d-sm-block d-md-block d-lg-none"></toggle-sidemenu>
                    <div class="ml-5 mt-3 d-none d-lg-block hover" @click="gotoMainPage()">
                        <img src="../assets/Logo.svg" class="MainNewLogo" alt="logo"/>                        
                    </div>                    
                </div>
                <div class="col-lg-3 col-md-2 col-sm-1 d-flex" v-else>
                    <sidemenu class="sidemenu d-none d-lg-block" ></sidemenu>
                    <toggle-sidemenu class="sidemenu d-block d-sm-block d-md-block d-lg-none"></toggle-sidemenu>
                </div>
                <div class="col-lg-9 col-11 col-sm-12 topmenubar">
                    <topmenu></topmenu>
                </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12" v-if="isOnline" >
            <router-view/>
        </div>
        <div class="col-lg-12" v-else>
            <noInternet @close = "retry"></noInternet>
        </div>
        
        <Footer class="footer d-block d-sm-block d-md-block d-lg-none" v-if="(routeName !== 'Premium' && routeName !== 'close' && routeName !=='payment_methods' && userType !== 'InternalUser')"/>
    </div>
</template>
<script>
import topmenu from "@/components/TopHeader.vue";
import sidemenu from "@/components/SideMenu.vue";
import Footer from '@/components/Footer';
import noInternet from '@/components/noInternet';
import toggleSidemenu from '@/components/ToggleSidemenu.vue'
import router from '../router.js'
import sessionUtils from '@/js/session-util.js'
import commonUtils from '@/js/common-utils.js'
export default {
    components: {
        sidemenu,
        topmenu,
        Footer,
        toggleSidemenu,
        noInternet
    },
    watch:{

    },
    data(){
        return{
            routeName : null,
            isOnline: navigator.onLine,
            interval : null,
            userType : null,
            profileId : null
        }
    },
    created() {
        var that = this;
        this.userType = localStorage.getItem("userType");
        this.profileId = sessionUtils.getUserProfileId();
        this.interval = setInterval(function(){ 
            that.routeName = that.$store.state.routeName;
            that.isOnline = navigator.onLine;
            let userId = sessionUtils.getUserId()
            if((userId === null || userId === undefined) && this.routeName !=='selectedloginviewjob' && this.routeName !== 'selectedloginviewuserprofile'){
                that.logout()
            }
            // console.log(that.isOnline)
        }, 500)
    },
    methods : {
        gotoMainPage(){
            commonUtils.scorlltop()
            if(!this.profileId){
                this.$router.push({
                name : 'welcome'
                })
            }else{
                sessionUtils.setSelectedElement('home')
            this.$router.push({
                name : 'MainHome'
                })
            }     
        },
        logout(){
            //make a rest call to capture a logout for the user
            this.$store.state.notificationCount = 0
            this.$session.clear();
            localStorage.setItem('isLoggedin', false);
            this.$session.destroy();
            localStorage.clear();
            this.$router.push("/signin");
            clearInterval(this.interval)
        },
        retry(){
            console.log('enter into retry')
            this.isOnline =  navigator.onLine;
        }
    },
    beforeDestroy(){
        clearInterval(this.interval)
    }
}
</script>
<style scoped>
.header {
    position: fixed;
    width: 100%;
    z-index: 4;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);;
}
.sidemenu {
    z-index: 5;
}
.hover{
  cursor: pointer;
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 5;
}
</style>